import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import FormInputText from '../../../common/Forms/FormTextField';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DialogHeader, DialogHeading } from '../../Episode.Styled';
import {
  EPISODE_CBP_AUTHORIZATION_UPDATE_URL,
  fieldRequired,
  formDateFormat,
} from '../../../../constants';
import {
  setAuthEndDate,
  setAuthStartDate,
  setDayQuantity,
} from '../../../../redux/episode/authTab/cbpAuthFormSlice';
import { postStopApi, setStopApi, deleteStopApi } from '../../../../services/StopApi/StopApi';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CbpAuthPdfDialog from './CbpAuthPdfDialog';
import {
  resetCbpAuthPdfForm,
  setCbpAuthPdfPrint,
} from '../../../../redux/episode/authTab/cbpAuthPdfSlice';
import {
  getFormSuccess,
  getSaveCancel,
} from '../../../common/commonUtils/commonUtils';

const schema = yup.object().shape({
  dayQuantity: yup.string().required(fieldRequired),
  authStartDate: yup.date().typeError(fieldRequired).required(),
  authEndDate: yup.date().typeError(fieldRequired).required(),
});

const CbpAuthDialog = (props) => {
  const { open, setOpen, openCbpBackdrop, authToken, 
          fetchAuth, loggedInContact, treatments, startDate } = props;

  const dispatch = useDispatch();
  const [openCbpAuthPdfDialog, setOpenCbpAuthPdfDialog] = useState(false);
  const [openCbpAuthPdfBackdrop, setOpenCbpAuthPdfBackDrop] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewCbpAuthForm, setIsNewCboAuthForm] = useState(false);

  const authForm = useSelector((state) => state?.authForm);
  const cbpAuthForm = useSelector((state) => state?.cbpAuthForm);
  const cbpAuthPdfForm = useSelector((state) => state?.cbpAuthPdfForm);

  const defaultValue = {
    cboAthId: cbpAuthForm?.cboAthId,
    dayQuantity: cbpAuthForm?.dayQuantity,
    authStartDate: startDate, //moment(cbpAuthForm?.authStartDate).format(formDateFormat),
    authEndDate: moment(cbpAuthForm?.authEndDate).format(formDateFormat),
  };
  dispatch(setAuthStartDate(startDate))

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, register, formState } = useFunction;

  const { errors } = formState;
  //dispatch(setCbpAuthPdfPrint(false));

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.cboAthId,
    defaultValue.dayQuantity,
    defaultValue.authStartDate,
    defaultValue.authEndDate,
  ]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
    dispatch(resetCbpAuthPdfForm());
  };

  const handleDelete = () => {
    const sapAthId = authForm?.authId;
    const url = `${EPISODE_CBP_AUTHORIZATION_UPDATE_URL}/${sapAthId}/Auth/CBPAuth`;
    const authorization = authToken;
    const payload = {
      cboAthId: cbpAuthForm?.cboAthId,
      sapAthId: authForm?.authId,
    };
    deleteStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        fetchAuth(sapAthId, false);
        setFormSuccess(true);
        setOpen(false);
      }
    }).catch((e) => alert(e));
  };

  const handlePrintCbpAuth = () => {
    setOpenCbpAuthPdfBackDrop(true);
    setOpenCbpAuthPdfDialog(true);
    if (cbpAuthPdfForm?.succeeded) {
      setOpenCbpAuthPdfBackDrop(false);
      //setTimeout(() => {
      //  dispatch(setCbpAuthPdfPrint(true));
      //}, 2000);
    }
  };

  const onSubmit = () => {
    const sapAthId = authForm?.authId;
    const url = `${EPISODE_CBP_AUTHORIZATION_UPDATE_URL}/${sapAthId}/Auth/CBPAuth`;
    const authorization = authToken;
    if (cbpAuthForm?.newCbpAuthForm === true) {
      const payload = {
        cboAthId: 0,
        sapAthId: authForm?.authId,
        cbpAuthEditedBy: loggedInContact.cntId,
        authEditDate: new Date(),
        cbpAuthCreatedBy: 17979,
        cbpAuthCreatedDate: new Date(),
        authStartDate: moment(cbpAuthForm?.authStartDate).format(
          formDateFormat
        ),
        dayQuantity: cbpAuthForm?.dayQuantity,
        authEndDate: moment(cbpAuthForm?.authEndDate).format(formDateFormat),
        cboAthInactiveYn: false,
        cboAthFlagYn: false,
        cboAthIsSecYn: false,
        cboAthSpDsc: null,
        cboAthDateAdm: null,
        cboAthCntyTrnfrYn: false,
        cboAthExpDateStart: null,
        cboAthWeekMaxUnt: null,
        cboAthApprRte: null,
      };
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchAuth(sapAthId, false);
          setIsNewCboAuthForm(true);
          setFormSuccess(true);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    } else {
      const payload = {
        cboAthId: cbpAuthForm?.cboAthId,
        sapAthId: authForm?.authId,
        cbpAuthEditedBy: loggedInContact.cntId,
        authEditDate: new Date(),
        authStartDate: moment(cbpAuthForm?.authStartDate).format(
          formDateFormat
        ),
        dayQuantity: cbpAuthForm?.dayQuantity,
        authEndDate: moment(cbpAuthForm?.authEndDate).format(formDateFormat),
        cboAthInactiveYn: false,
        cboAthFlagYn: false,
        cboAthIsSecYn: false,
        cboAthSpDsc: null,
        cboAthDateAdm: null,
        cboAthCntyTrnfrYn: false,
        cboAthExpDateStart: null,
        cboAthWeekMaxUnt: null,
        cboAthApprRte: null,
      };
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchAuth(sapAthId, false);
          setFormSuccess(true);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    }
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '800px',
            maxHeight: 'unset',
          },
        }}
      >
        {openCbpBackdrop ? (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openCbpBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            <DialogHeader>
              <DialogHeading variant='h5'>CBP Auth Detail: {defaultValue?.cboAthId}</DialogHeading>
              <Box>
                {/**
                <Button variant='contained' onClick={handlePrintCbpAuth}>
                  Print View
                </Button>
                **/}
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogHeader>
            <Grid container style={{ padding: '10px 40px' }}>
              <Grid container spacing={2}>
                {/**
                <Grid item xs={12} sm={6}>
                  <FormInputText
                    name='cboAthId'
                    type='text'
                    control={control}
                    disabled={true}
                    label='CBP Auth ID'
                  />
                </Grid>
                **/}
                <Grid item xs={12} sm={4}>  
                  <FormInputText
                    name='authStartDate'
                    type='date'
                    disabled
                    control={control}
                    shrink={true}
                    label='Start Date'
                    errors={!!errors.authStartDate}
                    helperText={errors?.authStartDate?.message}
                    //register={register('authStartDate', {
                    //  onChange: (e) =>
                    //    dispatch(setAuthStartDate(e.target.value)),
                    //})}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormInputText
                    name='dayQuantity'
                    type='number'
                    control={control}
                    label='Day Qty'
                    errors={!!errors.dayQuantity}
                    helperText={errors?.dayQuantity?.message}
                    register={register('dayQuantity', {
                      onChange: (e) =>
                        dispatch(
                          setDayQuantity(Number.parseInt(e.target.value))
                        ),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>  
                  <FormInputText
                    name='authEndDate'
                    type='date'
                    control={control}
                    shrink={true}
                    label='End Date'
                    errors={!!errors.authEndDate}
                    helperText={errors?.authEndDate?.message}
                    register={register('authEndDate', {
                      onChange: (e) => dispatch(setAuthEndDate(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              {getSaveCancel(handleClose, cbpAuthForm?.cboAthId == 0 || treatments.length > 0 ? null : handleDelete, handleSubmit(onSubmit))}
            </Grid>
          </>
        )}
      </Dialog>
      <CbpAuthPdfDialog
        open={openCbpAuthPdfDialog}
        setOpen={setOpenCbpAuthPdfDialog}
        openCbpAuthPdfBackdrop={openCbpAuthPdfBackdrop}
      />
      {getFormSuccess(formSuccess, setFormSuccess, isNewCbpAuthForm)}
    </>
  );
};

export default CbpAuthDialog;
